/**
 * Currency entity class
 */

/**
 * CurrencyFactory
 * returns Currency entity class
 *
 * @class CurrencyFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Currency} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CurrencyFactory
 */
/* @ngInject */
export default function CurrencyFactory (Entity) {
  /* === Currency class === */

  /**
   * Currency model
   *
   * @class Currency
   * @classdesc Currency model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.Currency} Currency entity
   */
  function Currency () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Currency.prototype = Object.create(Entity.prototype)
  Currency.prototype.constructor = Currency

  /* === Currency instance methods & fields === */

  Object.assign(Currency.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Currency#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      after: false,
      space: false,
      symbol: String,
      minAuthTransactionAmount: Number
    },

    /**
     * url template
     *
     * @memberof models.Currency#
     * @type {String}
     */
    _urlTemplate: 'api/currencies/{{::id}}'

  })

  /* === Currency static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Currency, Entity)
  Currency._name = 'Currency'
  Currency.init()

  // permissions
  Currency.access = {
    view: 'viewCurrency',
    create: 'createCurrency',
    edit: 'editCurrency',
    delete: 'deleteCurrency'
  }

  return Currency
}
